export const downloadTranslations = {
  DOWNLOAD_PAY_OFF: 'Download de Tranzer app.',
  DOWNLOAD_MAKE_US_POPULAR: 'Maak ons populair.'
};
